import { connect } from "react-redux";
import Reservation from "pages/secure/facility/reservation/Reservation";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";

const mapStateToProps = (state: any) => {
  return {
    uiStore: { ...state.uiStore },
    authStore: { ...state.authStore },
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reservation);
